import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AlertController } from '@ionic/angular';
import { ToastrService } from 'ngx-toastr';
import { Browser } from '@capacitor/browser';
import { App } from '@capacitor/app'; // Import App from @capacitor/app

@Component({
  selector: 'app-disabled',
  templateUrl: './disabled.component.html',
  styleUrls: ['./disabled.component.css']
})
export class DisabledComponent implements OnInit {

  platform = localStorage.getItem('platform');

  constructor(
    private toastr: ToastrService,
    public alertController: AlertController
  ) { }

  ngOnInit(): void { }

  goToDownload() {
    let url = "https://app.revenued.com";
    this.openWithSystemBrowser(url);
  }

  showExitConfirm() {
    this.alertController
      .create({
        header: '',
        message: 'Do you want to close the app?',
        backdropDismiss: false,
        buttons: [
          {
            text: 'Stay',
            role: 'cancel',
            handler: () => {
              console.log('Application exit prevented!');
            },
          },
          {
            text: 'Exit',
            handler: () => {
              App.exitApp(); // Correct usage of App.exitApp() in Capacitor
            },
          },
        ],
      })
      .then((alert) => {
        alert.present();
      });
  }

  // Open URL using the system browser with Capacitor's Browser plugin
  public async openWithSystemBrowser(url: string) {
    try {
      await Browser.open({ url: url });
    } catch (error) {
      console.error("Error opening browser: ", error);
    }
  }
}
